import Flex from '@Resources/styles/flex.scss';
import cx from 'classnames';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ModalFooter from '@Components/ModalComponents/ModalFooter';
import FilesApi from '@Data/files/Api';
import {
    FileUploadHeaderType,
    IFileUploadHeader,
} from '@Data/files/Interfaces';
import {
    fileUploadHeaders,
    fileUploadLatField,
    fileUploadLngField,
    fileUploadPoleIdField,
} from '@Data/files/Reducer';
import Styles from './FileUpload.scss';
import FileUploadHeaderSelector from './FileUploadHeaderSelector';

const SelectHeadersStep = (props) => {
    const { onSubmit, onBack, isSubmitting, setFooter } = props;

    const headers: Array<IFileUploadHeader> = useSelector(fileUploadHeaders);
    const latField: IFileUploadHeader = useSelector(fileUploadLatField);
    const lngField: IFileUploadHeader = useSelector(fileUploadLngField);
    const poleIdField: IFileUploadHeader = useSelector(fileUploadPoleIdField);

    const canSubmit =
        !_isNil(latField) && !_isNil(lngField) && !_isNil(poleIdField);

    const handleSelectHeader = (
        field: IFileUploadHeader,
        type: FileUploadHeaderType
    ) => {
        FilesApi.selectField(field, type);
    };

    const handleClearHeader = (type: FileUploadHeaderType) => {
        FilesApi.selectField(null, type);
    };

    const handleSubmit = () => {
        onSubmit(latField, lngField, poleIdField);
    };

    useEffect(() => {
        setFooter(
            <ModalFooter
                id="select-headers"
                onCancel={onBack}
                cancelText={'Back'}
                isSubmitting={isSubmitting}
                onSubmit={handleSubmit}
                canSubmit={canSubmit}
                submitText={`Submit Headers`}
            />
        );
    }, [isSubmitting, canSubmit]);

    return (
        <div
            id="file-upload-select-headers"
            className={cx(Flex.flex, Flex.column, Flex.alignItemsCenter)}
        >
            <div
                id="file-upload-select-helptext"
                className={Styles.fuHelpTextContainer}
            >
                Please select the latitude, longitude, and pole ID fields from
                the file's headers.
            </div>

            <div className={Styles.fuSelectContainer}>
                <div className={Styles.fuSelectorContainer}>
                    <FileUploadHeaderSelector
                        id="file-upload-select-latitude"
                        placeholder="Latitude"
                        options={headers}
                        selectedHeader={latField}
                        onSelect={(index) => {
                            handleSelectHeader(
                                index,
                                FileUploadHeaderType.LATITUDE
                            );
                        }}
                        onClear={() => {
                            handleClearHeader(FileUploadHeaderType.LATITUDE);
                        }}
                    />
                </div>
                <div className={Styles.fuSelectorContainer}>
                    <FileUploadHeaderSelector
                        id="file-upload-select-longitude"
                        placeholder="Longitude"
                        options={headers}
                        selectedHeader={lngField}
                        onSelect={(index) => {
                            handleSelectHeader(
                                index,
                                FileUploadHeaderType.LONGITUDE
                            );
                        }}
                        onClear={() => {
                            handleClearHeader(FileUploadHeaderType.LONGITUDE);
                        }}
                    />
                </div>
                <div className={Styles.fuSelectorContainer}>
                    <FileUploadHeaderSelector
                        id="file-upload-select-pole-id"
                        placeholder="Pole ID"
                        options={headers}
                        selectedHeader={poleIdField}
                        onSelect={(index) => {
                            handleSelectHeader(
                                index,
                                FileUploadHeaderType.POLE_ID
                            );
                        }}
                        onClear={() => {
                            handleClearHeader(FileUploadHeaderType.POLE_ID);
                        }}
                    />
                </div>
            </div>
            {/* <div className={Styles.fuDialogueFooter}>
                <ModalFooter
                    onCancel={onBack}
                    cancelText={"Back"}
                    isSubmitting={isSubmitting}
                    onSubmit={handleSubmit}
                    canSubmit={canSubmit()}
                    submitText={`Submit Headers`}
                />
            </div> */}
        </div>
    );
};

SelectHeadersStep.propTypes = {
    onBack: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setFooter: PropTypes.func,
};
export default SelectHeadersStep;
